<div class="p-grid">
    <div class="p-col-12">
        <app-filter [filterByInput]="cols" [filterByInputValue]="filterByInputValue" [selectedFilterGroup]="selectedFilterGroup"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
            (onApplyFilter)="onApplyFilter(selectedWindow, $event)" (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)" (onChangeRange)="onChangeRange(selectedWindow, $event)">
        </app-filter>
    </div>

    <div class="p-col-12">
        <div class="card">
            <div class="main-content">
                <div *ngIf="selectedWindow === 'userDeviceInfo'
                        || selectedWindow === 'userMobileAccess'
                        || selectedWindow=== 'loginHistory'
                        || selectedWindow==='loginHistoryDetails'  " id="divLeadsReport">
                            <app-reports-login [ReportName]="reportName" [OrganizationName]="OrganizationName"
                                [dateFrom]="dateFrom" [dateTo]="dateTo" [selectedWindow]="selectedWindow" [cols]="tableCols"
                                [products]="reportsData" [loading]="loading" [showRows]="showRows"
                                [IsShowReportTemplate]="IsShowReportTemplate" [firstPage]="firstPage"
                                [noContactFindOrLoadingText]="noContactFindOrLoadingText"></app-reports-login>
                </div>
                <div *ngIf="selectedWindow==='loginHistoryDetail'" id="divLeadsReport">
                    <app-table [reportType]="'groupTB'" [reportName]="reportName" [reportDate]="reportDate"
                    [selectedWindow]="selectedWindow"></app-table>
                </div>
            </div>
        </div>
    </div>
</div>
